"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelFontApi = void 0;
var ModelFontApi = (function () {
    function ModelFontApi(processor, internalItem) {
        this._internalItem = internalItem;
        this._processor = processor;
    }
    Object.defineProperty(ModelFontApi.prototype, "name", {
        get: function () {
            return this._internalItem.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ModelFontApi.prototype, "cssName", {
        get: function () {
            return this._internalItem.cssString;
        },
        enumerable: false,
        configurable: true
    });
    ModelFontApi.prototype.delete = function () {
        this._processor.modelManager.modelManipulator.font.removeFont(this._internalItem);
    };
    return ModelFontApi;
}());
exports.ModelFontApi = ModelFontApi;
